import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "cookie-consent-v2";
const DEFAULT = { necessary: true, analytics: false, functional: false };

const ConsentContext = createContext(null);

const applyPosthog = (analytics) => {
  try {
    if (window.posthog) {
      if (analytics) window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) { /* posthog not ready */ }
};

export const ConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(DEFAULT);
  const [decided, setDecided] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = JSON.parse(localStorage.getItem(KEY)); } catch (e) { stored = null; }
    if (stored) {
      const full = { ...DEFAULT, ...stored, necessary: true };
      setConsent(full);
      setDecided(true);
      applyPosthog(full.analytics);
    } else {
      applyPosthog(false); // block analytics until consent
    }
  }, []);

  const persist = useCallback((c) => {
    const full = { ...DEFAULT, ...c, necessary: true };
    localStorage.setItem(KEY, JSON.stringify(full));
    setConsent(full);
    setDecided(true);
    applyPosthog(full.analytics);
  }, []);

  const acceptAll = useCallback(() => { persist({ analytics: true, functional: true }); setManageOpen(false); }, [persist]);
  const rejectAll = useCallback(() => { persist({ analytics: false, functional: false }); setManageOpen(false); }, [persist]);
  const savePrefs = useCallback((c) => { persist(c); setManageOpen(false); }, [persist]);
  const openManage = useCallback(() => setManageOpen(true), []);

  const value = { consent, decided, manageOpen, setManageOpen, acceptAll, rejectAll, savePrefs, openManage };
  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
};

export const useConsent = () => useContext(ConsentContext);
